<template>
  <div class="data-table">
    <div class="d-header">
      <div class="pull-left seek">
        <slot name="search"></slot>
        <jsonExcel
          :ajaxGetKey="jsonExcelAjax.getKey"
          :ajaxPar="jsonExcelAjax.ajaxPar || false"
          :ajaxType="jsonExcelAjax.ajaxType"
          :ajaxUrl="jsonExcelAjax.url || false"
          :downloadLoading="downloadLoading"
          :downLoadTran="downLoadTran"
          :downloadUrl="jsonExcelAjax.downloadUrl || false"
          :keys="tableHead"
          :name="name"
          class="btn btn-default"
          v-if="jsonExcelAjax"
        >
          <i class="glyphicon glyphicon-save tab-he-glyphicon"></i>
          {{reuseLan.downloadExcelForms}}
        </jsonExcel>
      </div>
      <div class="pull-right tool-selPage" v-if="pageEnable">
        <span>{{reuseLan.showTotal}}</span>
        <dropdown menu-right>
          <btn class="dropdown-toggle">
            {{selPage.list[selPage.active]}}
            <span class="caret" style="margin-left:5px;"></span>
          </btn>
          <template slot="dropdown" v-for="(item,index) in selPage.list">
            <li @click="emitSelPage(index,item)" :key="index">
              <a role="button">{{item}}</a>
            </li>
          </template>
        </dropdown>
      </div>
      <slot name="more-filters"></slot>
      <div class="clear"></div>
    </div>
    <div class="d-section" style="overflow-x:auto; margin-bottom: 20px;">
      <div>
        <table :class="{'t': changeHeight}" class="table table-bordered table-hover">
          <thead>
            <tr style="white-space:nowrap;">
              <th @click="emitSort(item.key)" v-for="item in tableHead" :key="item.key">
                {{item.value}}
                <span
                  @click.stop
                  class="caret-wrapper"
                  v-if="(sort && sort.list.indexOf(item.key) > -1) || sort.list === 'All'"
                >
                  <i
                    :style="{color: (sort.active.key==item.key && sort.active.order == 'ASC') ? '#409eff': '#aaa'}"
                    @click="emitSort(item.key,'ASC')"
                    class="el-icon-caret-top"
                  ></i>
                  <i
                    :style="{color: (sort.active.key==item.key && sort.active.order == 'DESC') ? '#409eff': '#aaa'}"
                    @click="emitSort(item.key,'DESC')"
                    class="el-icon-caret-bottom"
                  ></i>
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr 
                :class="{'less-zero': +tbody['TOTAL_PL'] > 0 }" 
                :style="`white-space:nowrap;${tbody.bgColor ? 'background-color:#e4effe;' : ''}`" 
                v-for="(tbody, tbodyIndex) in tbodyData" 
                :key="tbodyIndex"
            >
              <td v-for="head in tableHead" :key="head.key">
                <el-tooltip v-if="tip && tip.includes(head.key) && tbody[head.key]">
                  <div slot="content">
                    <span v-for="(tips,value) in JSON.parse(tbody[head.key])" :key="value">
                      {{value}}&nbsp;&nbsp;:&nbsp;&nbsp;{{tips}}
                      <br />
                    </span>
                  </div>
                  <span
                    v-if="tbody[head.key] && tbody[head.key].length > 40"
                    v-text="tbody[head.key].substr(0, 40) + '...'"
                  ></span>
                  <span v-else v-text="tbody[head.key]"></span>
                </el-tooltip>
                <span v-else-if="head.redColor" :style="+tbody[head.key] < 0 ? 'color:red;' : ''" v-text="tbody[head.key]"></span>
                <span v-else v-text="tbody[head.key]"></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="noData" v-if="tbodyData.length === 0">
        <i aria-hidden="true" class="fa fa-exclamation-circle"></i>
        {{noDataMessage === "" ? reuseLan.noData : noDataMessage}}
      </div>
    </div>
    <div class="d-footer" v-if="pageEnable">
      <div class="pull-left number-entries">
        {{reuseLan.total}} {{page.pageLeng || '*'}}
        {{reuseLan.current}}
        {{(page.active - 1)*selPage.limit + 1}}-
        {{page.pageLeng ? Math.min(page.active*selPage.limit, page.pageLeng) : (page.active*selPage.limit - (tbodyData.length == selPage.limit ? 0 : (selPage.limit - tbodyData.length))) }}
      </div>
      <div class="pull-right">
        <pagination
          :total-page="page.pageLeng ? Math.ceil(page.pageLeng/selPage.limit) : (page.active + (tbodyData.length == selPage.limit))"
          @change="callpageFn"
          boundary-links
          style="height: 32px;"
          v-model="page.active"
        ></pagination>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import jsonExcel from './excel'
import { mapMutations } from 'vuex'
import { Dropdown, Btn, Pagination } from 'uiv'
export default {
  mixins: [require('common/mixin/base').base({ reuseLan: 'reuse' })],
  props: {
    tableHead: {
      type: Array,
      default: () => []
    },
    tbodyData: {
      type: Array,
      default: () => []
    },
    pageEnable: {
      default: true
    },
    changeHeight: {
      default: false
    },
    page: {
      type: Object,
      default: () => {}
    },
    selPage: {
      type: Object,
      default: () => {}
    },
    tip: {
      default: false
    },
    jsonExcelAjax: {
      // 下载Excel
      default: false
    },
    name: {
      default: ''
    },
    sort: {
      default: false
    },
    downLoadTran: {
      type: Object,
      default: () => {}
    },
    downloadLoading: {
      type: Boolean,
      default: false
    },
    noDataMessage: {
      type: String,
      default: ""
    },
  },
  components: {
    Dropdown,
    Btn,
    Pagination,
    jsonExcel
  },
  data() {
    return {}
  },
  methods: {
    emitSelPage(index, item) {
      // 选择一页显示的条目数量
      this.SAVEPAGEMAXINDEX(index)
      this.$parent.selPage.active = index
      this.$parent.selPage.limit = this.selPage.list[this.selPage.active]
      this.$parent.page.offset = 0
      this.$parent.page.active = 1
      this.$emit('tableChange')
    },
    emitSort(sortKey, sequence) {
      if (this.sort.list && (this.sort.list == 'All' || this.sort.list.includes(sortKey))) {
        let key = this.sort.active.key
        let order = this.sort.active.order
        order = sequence ? sequence : key == sortKey ? (order == 'DESC' ? '' : order == 'ASC' ? 'DESC' : 'ASC') : 'ASC'
        this.$parent.sort.active.key = this.sort.active.key = sortKey
        this.$parent.sort.active.order = this.sort.active.order = order
        this.$emit('tableChange')
      }
    },
    callpageFn(index) {
      // 翻页回调
      this.$parent.page.active = index
      this.$parent.page.offset = this.selPage ? (this.page.active - 1) * this.selPage.list[this.selPage.active] : ''
      this.$emit('tableChange')
    },
    ...mapMutations(['SAVEPAGEMAXINDEX'])
  }
}
</script>


<style lang="scss" scoped>
.data-table {
  .d-header {
    padding: 20px 20px 25px;
    line-height: 34px;
    .btn-default {
      padding: 10px 12px;
    }
  }
  .d-section {
    .less-zero {
      color: #409eff;
    }
    .table-bordered {
      border: 0;
      border-top: 0;
      border-collapse: collapse;
    }
    .caret-wrapper {
      display: inline-flex;
      flex-direction: column;
      vertical-align: middle;
      margin-top: -5px;
      cursor: pointer;
    }
    .table thead {
      border-top: 1px solid #ddd;
      tr th,
      tr td {
        border-bottom: 1px solid #bbb;
      }
      tr th {
        font-weight: normal;
      }
    }
    .table thead tr td:first-child,
    .table thead tr th:first-child,
    .table tbody tr td:first-child {
      border-left: 0;
    }
    .table thead tr td:last-child,
    .table thead tr th:last-child,
    .table tbody tr td:last-child {
      border-right: 0;
    }
    .table tbody tr .last-td {
      text-align: center;
      font-size: 16px;
      cursor: pointer;
      color: #000;
    }

    .table > tbody > tr > td,
    .table > tbody > tr > th,
    .table > tfoot > tr > td,
    .table > tfoot > tr > th,
    .table > thead > tr > td,
    .table > thead > tr > th {
      padding: 12px 20px;
      line-height: 1.5384616;
      vertical-align: top;
      border-top: 1px solid #ddd;
    }

    .t > tbody > tr > td,
    .t > tbody > tr > th,
    .t > tfoot > tr > td,
    .t > tfoot > tr > th,
    .t > thead > tr > td,
    .t > thead > tr > th {
      line-height: 0.2;
    }

    .noData {
      font-size: 16px;
      text-align: center;
      i {
        margin-right: 5px;
      }
    }
  }
  .d-footer {
    padding: 0 20px 20px;
    .number-entries {
      line-height: 32px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/reuseTable.vue